import clsx from 'clsx'

import CompetitorLogo from '../CompetitorLogo'
import type { GapReportDocument } from '@pepper/utils/src/types/seo'

import s from './PageContentLength.module.css'

type Props = {
  document: GapReportDocument['document']
}

const PageContentLength = ({ document }: Props) => {
  const competitorLength = document.competitor_stats.length
  const pageLength = document.page_length
  const competitors = document.competitors.sort((a, b) => a.length - b.length)

  const lenMin =
    Math.floor(competitorLength.min / 100) * 100 || competitorLength.min
  const lenMax = Math.floor(competitorLength.max / 100) * 100

  const rankLengthPercent =
    competitorLength.max > pageLength
      ? 100
      : (competitorLength.max / pageLength) * 100
  const pageLengthPercent =
    pageLength > competitorLength.max
      ? 100
      : (pageLength / competitorLength.max) * 100

  const getLength = (length: number) => {
    const lengthPercent = (length / competitorLength.max) * 100
    if (length === competitorLength.max) return rankLengthPercent
    return lengthPercent
  }

  return (
    <div className={s.wrapper}>
      <div className={s.progress}>
        <div className={s.prefix}>Average Ranking Pages</div>
        <div className={clsx(s.outer, s.blue)}>
          <div className={clsx(s.line, s.start)} />
          {competitors.map(competitor => (
            <div
              key={competitor.url}
              className={clsx(s.lineGroup, s.start)}
              style={{
                left: `${getLength(competitor.length)}%`,
              }}
            >
              <div className={s.line} />
              <div className={s.avatars}>
                <CompetitorLogo competitor={competitor} />
              </div>
            </div>
          ))}
          <div
            className={s.inner}
            style={{
              width: `${rankLengthPercent}%`,
            }}
          />
          <div
            className={s.grayBar}
            style={{
              width: `${getLength(competitors[0].length)}%`,
            }}
          />
        </div>
        <div className={s.suffix}>
          {lenMin}-{lenMax} words
        </div>
      </div>
      <div className={s.progress}>
        <div className={s.prefix}>Your Page</div>
        <div
          className={clsx(s.outer, pageLength >= lenMin ? s.green : s.orange)}
        >
          <div
            className={s.inner}
            style={{
              width: `${pageLengthPercent}%`,
            }}
          />
        </div>
        <div className={s.suffix}>{pageLength} words</div>
      </div>
    </div>
  )
}

export default PageContentLength
